import { ApiInstance } from '@src/services/api-instance';
import { ToolsScriptsService } from './scripts/api-scripts';

export class ToolsV1Service {
  private readonly client: ApiInstance;

  public scripts: ToolsScriptsService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/v1`, client.getTimeout());

    this.scripts = new ToolsScriptsService(this.client);
  }
}
